module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "overflow-y": "auto",
      "background-color": "#eee"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "absolute": "",
      "flat": "",
      "dark": "",
      "dense": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Components")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("search")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticStyle: {
      "top": "48px"
    },
    attrs: {
      "absolute": "",
      "mobile-break-point": 900,
      "width": 240
    }
  }, [_c('v-toolbar', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', [_c('v-list-item', [_c('v-list-item-title', {
    staticClass: "title"
  }, [_vm._v("\n            Application\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item', [_c('v-list-item-action', [_c('v-icon', [_vm._v("security")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Security")])], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-list-item-action', [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("People")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticStyle: {
      "top": "48px",
      "background-color": "#ddd"
    },
    attrs: {
      "right": "",
      "absolute": "",
      "mobile-break-point": 1200,
      "width": 350
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, _vm._l((100), function(n) {
    return _c('span', {
      staticStyle: {
        "color": "#bbb"
      }
    }, [_vm._v("Lorem ipsum, dolor sit amet consectetur adipisicing elit. Expedita quam nobis fugiat iusto illum officia facilis dolor debitis assumenda, sit iure odio laboriosam autem obcaecati minima repudiandae, quidem cupiditate aliquam! ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "main-page"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "#eee",
      "padding": "0 5px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0 auto",
      "max-width": "600px"
    }
  }, [_c('SectionLayout', {
    attrs: {
      "section-properties": {
        title: 'Personal Details',
      }
    }
  }, [_c('ElementLayout', {
    attrs: {
      "element-properties": {
        title: 'First Name',
        complete: true,
        icon: 'account_circle',
      }
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "First Name",
      "xxxbox": "",
      "hide-details": ""
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "right-button",
    attrs: {
      "slot": "right",
      "small": "",
      "outline": "",
      "color": "grey"
    },
    slot: "right"
  }, [_vm._v("Lookup")])], 1), _vm._v(" "), _c('ElementLayout', {
    attrs: {
      "element-properties": {
        title: 'Last Name',
        complete: false
      }
    }
  }, [_c('LayoutReadOnly', {
    attrs: {
      "label": "Middle Name",
      "value": "Jenson"
    }
  })], 1), _vm._v(" "), _c('ElementLayout', {
    attrs: {
      "element-properties": {
        complete: true
      }
    }
  }, [_c('LayoutReadOnly', {
    attrs: {
      "label": "Preferred Name (or Nickname)",
      "value": "PJ"
    }
  })], 1), _vm._v(" "), _c('ElementLayout', {
    attrs: {
      "element-properties": {
        title: 'Last Name',
        complete: false
      }
    }
  }, [_c('LayoutReadOnly', {
    attrs: {
      "label": "Spouses Name",
      "value": "Maria"
    }
  })], 1), _vm._v(" "), _c('ElementLayout', {
    attrs: {
      "element-properties": {
        title: 'Last Name',
        complete: false
      }
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Last Name",
      "xxxbox": "",
      "hide-details": ""
    }
  })], 1), _vm._v(" "), _c('ElementLayout', {
    attrs: {
      "element-properties": {
        title: 'Favourite Colour',
        complete: false
      }
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Favourite Colour",
      "hide-details": "",
      "items": ['Red', 'Orange', 'Yellow', 'Green']
    }
  })], 1)], 1), _vm._v(" "), _c('SectionLayout', {
    attrs: {
      "section-properties": {
        title: 'Contact Preferences',
      }
    }
  }, [_vm._v("\n                Section 2\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "elevation-2 pa-3 mb-2 mt-5",
    staticStyle: {
      "background-color": "white"
    }
  }, [_vm._v("\n\n        Contact Autocomplete\n        "), _c('ContactAutocomplete', {
    attrs: {
      "items": _vm.contacts,
      "single-line": ""
    },
    model: {
      value: (_vm.selectedContacts),
      callback: function($$v) {
        _vm.selectedContacts = $$v
      },
      expression: "selectedContacts"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n        DateTime\n        "), _c('DateTime', {
    attrs: {
      "label": "Appointment Time"
    },
    model: {
      value: (_vm.dateAndTime),
      callback: function($$v) {
        _vm.dateAndTime = $$v
      },
      expression: "dateAndTime"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n        Dynamic Control\n        "), _c('DynamicControl', {
    attrs: {
      "field": _vm.specialField
    },
    model: {
      value: (_vm.specialValue),
      callback: function($$v) {
        _vm.specialValue = $$v
      },
      expression: "specialValue"
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bc1b3c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Components.vue
// module id = 2511
// module chunks = 1